import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    root: {
      display: "flex",
      height: 14,
      padding: "1px 7px 0",
      color: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 10,
      borderRadius: 7,
      textTransform: "uppercase",
      "&.details": {
        height: 20,
        fontSize: 12,
        borderRadius: 24,
        paddingLeft: 12,
        paddingRight: 12,
        alignItems: "center"
      }
    },
    button: {
      minWidth: "auto",
      "& .MuiButton-label": {
        lineHeight: "8px"
      }
    },
    low: {
      border: `1px solid ${primary.main}`,
      paddingTop: 0
    },
    medium: {
      backgroundColor: "#ffe08f",
      "&:hover": {
        backgroundColor: "rgba(255, 224, 143, 1)"
      },
      "& .MuiTouchRipple-child": {
        backgroundColor: "rgba(193, 151, 45, 1)"
      }
    },
    high: {
      backgroundColor: "#ff4b4f",
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: "#ff4b4f"
      },
      "& .MuiTouchRipple-child": {
        backgroundColor: "rgba(132, 39, 50, 1)"
      }
    }
  };
});
